/* Bean Shipper homepage scroll film (29 Oct 2026, Kai: "recreate homepage hero to be scroll like using a
   highlight folder photo with higgsfield"). sections/index__bs-home-x.liquid renders it when Hero style is
   "Scroll film": a poster <img> (frame 1, visible without this file), a canvas over it and the frame list as
   JSON. The frames are a Higgsfield Kling 3.0 push-in from highlight photo BS-27 copy, in Content > Files.
   This file draws the frame that matches how far the hero has been scrolled. Enhancement only: without it,
   or with reduced motion, the poster stays put and the copy scrolls over it. Frames load after the page has
   loaded, coarse to fine, so a frame is always near; Save-Data, 2G/3G and phones with 2 GB of memory or
   less load a lighter set. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bsx-scrollhero]');
  if (!root || root.__bsxFilm) return;
  root.__bsxFilm = true;

  function mm(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  var track = root.querySelector('.bshx-sh__track');
  var stage = root.querySelector('.bshx-sh__stage');
  var media = root.querySelector('.bshx-sh__media');
  var cv = root.querySelector('.bshx-sh__cv');
  var data = root.querySelector('[data-bsx-frames]');
  var header = document.querySelector('header.nav');

  /* The stage pins under the fixed header, wherever the header sits (the promo strip moves it down). */
  function setTop() {
    var t = 0;
    if (header) {
      var r = header.getBoundingClientRect();
      if (r.bottom > 0 && r.bottom < window.innerHeight * 0.4) t = Math.round(r.bottom);
    }
    if (t > 0) root.style.setProperty('--sh-top', t + 'px');
  }
  setTop();
  window.addEventListener('load', setTop);

  if (!track || !stage || !media || !cv || !data || !cv.getContext || mm('(prefers-reduced-motion: reduce)')) return;
  var urls = [];
  try { urls = JSON.parse(data.textContent || '[]'); } catch (e) { urls = []; }
  var n = urls.length;
  if (n < 2) return;

  var ctx = cv.getContext('2d');
  var conn = navigator.connection || {};
  var lite = !!conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
  var lowmem = !!(navigator.deviceMemory && navigator.deviceMemory <= 2);
  var HOLD = 0.86; /* the last stretch of the scroll rests on the final frame while the closing card arrives */
  var imgs = new Array(n), ok = new Array(n);
  var want = 0, cur = -1, raf = 0, W = 0, H = 0, started = false, px = 720;

  function size() {
    var r = media.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
    if (w !== W || h !== H) { W = cv.width = w; H = cv.height = h; cur = -1; }
    var cap = mm('(min-width: 768px)') ? 1080 : 720;
    if (!started) px = lite ? 540 : Math.min(cap, Math.max(540, Math.ceil(r.width * dpr / 180) * 180));
  }

  function nearest(i) {
    if (ok[i]) return i;
    for (var d = 1; d < n; d++) {
      if (i - d >= 0 && ok[i - d]) return i - d;
      if (i + d < n && ok[i + d]) return i + d;
    }
    return -1;
  }

  function draw() {
    raf = 0;
    var i = nearest(want);
    if (i < 0 || i === cur) return;
    var im = imgs[i], iw = im.naturalWidth || 1, ih = im.naturalHeight || 1;
    var s = Math.max(W / iw, H / ih), dw = iw * s, dh = ih * s;
    ctx.drawImage(im, (W - dw) / 2, (H - dh) / 2, dw, dh);
    cur = i;
  }
  function paint() { if (!raf) raf = requestAnimationFrame(draw); }

  /* 0 at the top of the page, 1 when the stage lets go at the end of the hero. */
  function progress() {
    var r = track.getBoundingClientRect();
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var top = parseFloat(getComputedStyle(stage).top) || 0;
    var end = (r.top + y) - top - stage.offsetHeight + r.height;
    if (end <= 0) return 0;
    var p = y / end;
    return p < 0 ? 0 : p > 1 ? 1 : p;
  }

  function onScroll() {
    var p = progress() / HOLD;
    if (p > 1) p = 1;
    want = Math.round(p * (n - 1));
    if (!started && want > 0) start();
    paint();
  }

  function order() {
    var o = [], seen = {}, steps = lite ? [8, 4] : lowmem ? [16, 8, 4, 2] : [16, 8, 4, 2, 1];
    for (var k = 0; k < steps.length; k++) {
      for (var i = 0; i < n; i += steps[k]) if (!seen[i]) { seen[i] = 1; o.push(i); }
    }
    if (!seen[n - 1]) o.push(n - 1);
    return o;
  }

  function src(i) { return urls[i].replace(/([?&])width=\d+/, '$1width=' + px); }

  function start() {
    if (started) return;
    started = true;
    var q = order(), k = 0, busy = 0, MAX = 6;
    function next() {
      while (busy < MAX && k < q.length) {
        (function (i) {
          busy++;
          var im = new Image();
          im.decoding = 'async';
          if ('fetchPriority' in im) im.fetchPriority = 'low';
          im.onload = function () { busy--; imgs[i] = im; ok[i] = true; paint(); next(); };
          im.onerror = function () { busy--; next(); };
          im.src = src(i);
        })(q[k++]);
      }
    }
    next();
  }

  size();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () { setTop(); size(); onScroll(); }, 120);
  });
  window.addEventListener('pageshow', function () { cur = -1; onScroll(); });
  function kick() { (window.requestIdleCallback || function (f) { return setTimeout(f, 400); })(start, { timeout: 2500 }); }
  if (document.readyState === 'complete') kick(); else window.addEventListener('load', kick);
})();
